import { useEffect } from 'react';
import WebApp from '@twa-dev/sdk';

// PARA-105 §7 — интеграция push-экранов с нативной кнопкой "Назад" Telegram.
export function useTelegramBackButton(enabled: boolean, onBack: () => void): void {
  useEffect(() => {
    if (!enabled) {
      WebApp.BackButton.hide();
      return;
    }
    WebApp.BackButton.show();
    WebApp.BackButton.onClick(onBack);
    return () => {
      WebApp.BackButton.offClick(onBack);
      WebApp.BackButton.hide();
    };
  }, [enabled, onBack]);
}
